import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

// Guard que restringe el acceso a /loginfacturacion solo en environments FGAU. 23/07/2026
@Injectable({
  providedIn: 'root'
})
export class LoginFacturacionGuard implements CanActivate {

  // Ambientes donde /loginfacturacion es accesible
  private allowedAmbientes = [
    'devfactorajeau',
    'testfactorajeau',
    'prodfactorajeau',
    'testfactoraje',
    'prodfactoraje'
  ];

  constructor(private router: Router) {}

  canActivate(): boolean {
    const ambiente = environment.Ambiente.toLowerCase();
    if (this.allowedAmbientes.includes(ambiente)) {
      return true;
    }
    // Si no es un ambiente permitido, redirigir a acceso denegado
    this.router.navigate(['/accesodenegado']);
    return false;
  }
}
